<template>
  <div>
    <el-card>
      <el-form ref="mainForm" :model="mainForm.data" :rules="verifyRules.goodsManagerProductAdd.mainForm" label-width="160px">
        <el-row :gutter="12">
          <el-col :md="24" :lg="6">
            <!-- 上架 -->
            <el-form-item :label="$t('form.product.online')" prop="online">
              <el-switch v-model="mainForm.data.online"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- 推荐 -->
            <el-form-item :label="$t('form.product.recommend')" prop="recommend">
              <el-switch v-model="mainForm.data.recommend"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- Support seven days return -->
            <el-form-item :label="$t('form.product.sevenDaysReturn')" prop="support_seven_days_return">
              <el-switch v-model="mainForm.data.support_seven_days_return"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- 可搜索 -->
            <el-form-item :label="$t('form.product.searchable')" prop="searchable">
              <el-switch v-model="mainForm.data.searchable"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="6">
            <!-- 订单免邮 -->
            <el-form-item :label="$t('form.product.freeDelivery')" prop="free_delivery">
              <el-switch v-model="mainForm.data.free_delivery"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- 独家商品 -->
            <el-form-item :label="$t('form.product.exclusiveGoods')" prop="show_in_related_clients">
              <el-switch v-model="mainForm.data.show_in_related_clients"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="8" v-if="mainForm.data.support_seven_days_return">
            <!-- 售后窗口 -->
            <el-form-item :label="$t('form.product.afterSalesWindow')" prop="after_sales_window">
              <el-input type="number" v-model.number="mainForm.data.after_sales_window" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 定时开售 -->
            <el-form-item :label="$t('form.product.regularSale')" prop="online_time">
              <el-date-picker v-model="mainForm.data.online_time" class="width-fill" type="datetime" :placeholder="$t('placeholder.defaultSelect')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 排序 -->
            <el-form-item :label="$t('form.product.ranking')" prop="rank">
              <el-input type="number" v-model="mainForm.data.rank" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 店铺 -->
            <el-form-item :label="$t('form.common.shop')" prop="shop_id">
              <el-select v-model="mainForm.data.shop_id" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" disabled @change="handleMainFormShopSelectChange">
                <el-option v-for="(item, index) in shopList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 供货商 -->
          <!-- <el-col :md="24" :lg="8">
            <el-form-item :label="$t('form.product.supplier')" prop="supplier_id">
              <el-select v-model="mainForm.data.supplier_id" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable>
                <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :md="24" :lg="8">
            <!-- 商品类型 -->
            <el-form-item :label="$t('form.product.shopType')" prop="item_type">
              <el-select :disabled="true" v-model="mainForm.data.item_type" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" :loading="mainForm.itemTypeSelect.loading" filterable @change="handleMainFormItemTypeSelectChange">
                <el-option v-for="(item, index) in itemTypeList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :md="24" :lg="8" v-show="mainForm.data.item_type === 'pack_info' || mainForm.data.item_type === 'ticket_package' || mainForm.data.item_type === 'package' || mainForm.data.item_type === 'multi_park_ticket'|| mainForm.data.item_type === 'single_ticket'|| mainForm.data.item_type === 'bundle_ticket'"> -->
          <!-- 景点 -->
          <!-- <el-form-item :label="$t('form.attractions.site')" prop="site_id">
              <el-select
                :disabled="true"
                v-model="mainForm.data.site_id"
                class="width-fill"
                :placeholder="$t('placeholder.defaultSelect')"
s                filterable
                @change="handleMainFormSiteSelectChange"
              >
                <el-option v-for="(item, index) in siteList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :md="24" :lg="8" v-show="mainForm.data.item_type === 'pack_info' || mainForm.data.item_type === 'multi_park_ticket'|| mainForm.data.item_type === 'single_ticket'|| mainForm.data.item_type === 'bundle_ticket'">
            <!-- 门票 -->
            <el-form-item :label="getName()" prop="itemable_id">
              <el-select :disabled="true" v-model="mainForm.data.itemable_id" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" @change="handleTicketChange" filterable>
                <el-option v-for="(item, index) in packInfoList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if=" mainForm.data.item_type === dataDictionary['003']['002'].code || mainForm.data.item_type === dataDictionary['003']['005'].code
            || mainForm.data.item_type === dataDictionary['003']['006'].code || mainForm.data.item_type === dataDictionary['003']['007'].code
            || mainForm.data.item_type === dataDictionary['003']['008'].code || mainForm.data.item_type === dataDictionary['003']['009'].code" :md="24" :lg="8">
            <!-- 线下优惠券 -->
            <el-form-item :label="getName()">
              <el-select @change="handlePackageChange" v-model="mainForm.data.itemable_id" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable>
                <el-option v-for="(item, index) in itemablesList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 商品类别 -->
            <el-form-item :label="$t('form.product.shopCategories')" prop="category_ids">
              <el-select v-model="mainForm.data.category_ids" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" multiple filterable :loading="mainForm.categorieSelect.loading">
                <el-option v-for="(item, index) in categoriesList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 商品子类别 -->
            <el-form-item :label="$t('form.product.shopSubCategories')" prop="shop_sub_category_ids">
              <el-select v-model="mainForm.data.shop_sub_category_ids" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" multiple filterable :loading="mainForm.subCategorieSelect.loading">
                <el-option v-for="(item, index) in subCategoriesList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 支持批发 -->
          <el-col :md="24" :lg="8" v-if="appName.includes('wholesale')">
            <el-form-item :label="$t('form.product.supportWholesale')" prop="wholesale_type">
              <el-select v-model="mainForm.data.wholesale_type" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable>
                <el-option v-for="(item, index) in wholesaleTypeList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 中文名称 -->
            <el-form-item :label="$t('form.common.cnName')" prop="name">
              <el-input @change="(data) => { return handleChange(data, 'name') }" v-model="mainForm.data.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="8">
            <!-- 英文名称 -->
            <el-form-item :label="$t('form.common.enName')" prop="name_en">
              <el-input @change="(data) => { return handleChange(data, 'name') }" v-model="mainForm.data.name_en" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="8">
            <!-- 初始销量 -->
            <el-form-item :label="$t('form.product.initSale')" prop="init_sale">
              <el-input v-model="mainForm.data.init_sale" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="mainForm.data.item_type === dataDictionary['003']['001'].code || mainForm.data.item_type === dataDictionary['003']['003'].code" :md="24" :lg="8">
            <!-- 同一用户购买上限 -->
            <el-form-item :label="$t('form.product.maximumLimitPerUser')" prop="maximum_limit_per_user">
              <el-input v-model="mainForm.data.maximum_limit_per_user" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="24">
            <!-- 简要描述(中文) -->
            <el-form-item :label="$t('form.product.shortDescriptionCn')" prop="short_description">
              <el-input v-model="mainForm.data.short_description" type="textarea" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.TEXT_AREA.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="24">
            <!-- 简要描述(英文) -->
            <el-form-item :label="$t('form.product.shortDescriptionEn')" prop="short_description_en">
              <el-input v-model="mainForm.data.short_description_en" type="textarea" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.TEXT_AREA.MAX_LENGTH.COMMON"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="24">
            <!-- 描述(中文) -->
            <el-form-item :label="$t('form.product.descriptionCn')" prop="description">
              <quill-editor v-model="mainForm.data.description" :options="quillOption"></quill-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="24">
            <!-- 描述(英文) -->
            <el-form-item :label="$t('form.product.descriptionEn')" prop="description_en">
              <quill-editor v-model="mainForm.data.description_en" :options="quillOption"></quill-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :md="24" :lg="8">
            <!-- 全局标签 -->
            <el-form-item :label="$t('form.product.globalLabels')" prop="global_labels">
              <el-select v-model="mainForm.data.global_labels" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" multiple filterable>
                <el-option v-for="(item, index) in globalLabelsList" :key="index" :label="item.display_name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="appName.includes('wholesale')">
          <el-col :md="24" :lg="8">
            <el-form-item :label="$t('form.product.invisibleFor')" prop="global_labels">
              <el-select v-model="mainForm.data.invisible_for_user_groups" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" multiple filterable>
                <el-option v-for="(item, index) in userGroupList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="mainForm.data.item_type === 'food' || mainForm.data.item_type === 'normal'">
          <!-- <el-col :md="24" :lg="8"> -->
          <!-- 特别属性 -->
          <!-- <el-form-item
              v-if="mainForm.data.item_type === dataDictionary['003']['001'].code || mainForm.data.item_type === dataDictionary['003']['003'].code"
              :label="$t('form.product.specialProperties')"
              prop="special_attributes"
            >
              <el-select v-model="mainForm.data.special_attributes" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" multiple filterable>
                <el-option v-for="(item, index) in dataDictionary['002']" :key="index" :label="item.text" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :md="24" :lg="6">
            <!-- 冷藏品 -->
            <el-form-item :label="$t('text.refrigeratedProduct')" prop="refrigerated">
              <el-switch v-model="mainForm.data.refrigerated"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- 冷冻品 -->
            <el-form-item :label="$t('text.frozenProduct')" prop="frozen_product">
              <el-switch v-model="mainForm.data.frozen_product"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="24" :lg="6">
            <!-- non hala -->
            <el-form-item :label="$t('Non halal')" prop="non_halal">
              <el-switch v-model="mainForm.data.non_halal"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse :value="[1, 2, 3, 4, 5, 6]">
          <!-- 特色标签开始 -->
          <el-collapse-item v-if="
              mainForm.data.item_type === dataDictionary['003']['001'].code ||
              mainForm.data.item_type === dataDictionary['003']['002'].code ||
              mainForm.data.item_type === dataDictionary['003']['003'].code ||
              mainForm.data.item_type === dataDictionary['003']['004'].code ||
              mainForm.data.item_type === dataDictionary['003']['005'].code ||
              mainForm.data.item_type === dataDictionary['003']['007'].code ||
              mainForm.data.item_type === dataDictionary['003']['008'].code ||
              mainForm.data.item_type === 'ticket_package'||
              mainForm.data.item_type === 'package' ||
              mainForm.data.item_type === 'multi_park_ticket'||
              mainForm.data.item_type === 'single_ticket'||
              mainForm.data.item_type === 'bundle_ticket'
            " :title="$t('form.product.featuredTags')" :name="1">
            <el-row v-for="(item, index) in mainForm.data.special_labels_attributes" :key="index" v-show="item._destroy !== true" class="mb-interval-tiny">
              <el-col :md="24" :lg="8" class="mr-interval-small mb-interval-tiny">
                <el-form-item :label="$t('form.common.cnName')" :prop="`special_labels_attributes.${index}.name`">
                  <el-input v-model="item.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="24" :lg="8" class="mr-interval-small mb-interval-tiny">
                <el-form-item :label="$t('form.common.enName')" :prop="`special_labels_attributes.${index}.name_en`">
                  <el-input v-model="item.name_en" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                </el-form-item>
              </el-col>
              <el-button type="danger" @click="() => handleMainFormSpecialLabelsItemDelBtnClick(item, index)">{{ $t('button.delete') }}</el-button>
            </el-row>
            <el-form-item>
              <el-button icon="el-icon-plus" @click="handleMainFormSpecialLabelsAddBtnClick">{{ $t('button.add') }}</el-button>
            </el-form-item>
          </el-collapse-item>
          <!-- 特色标签结束 -->
          <!-- 不可见标签开始 -->
          <el-collapse-item v-if="
              mainForm.data.item_type === dataDictionary['003']['001'].code ||
              mainForm.data.item_type === dataDictionary['003']['002'].code ||
              mainForm.data.item_type === dataDictionary['003']['003'].code ||
              mainForm.data.item_type === dataDictionary['003']['004'].code ||
              mainForm.data.item_type === dataDictionary['003']['005'].code ||
              mainForm.data.item_type === dataDictionary['003']['007'].code ||
              mainForm.data.item_type === dataDictionary['003']['008'].code ||
              mainForm.data.item_type === 'ticket_package'||
              mainForm.data.item_type === 'package'||
              mainForm.data.item_type === 'multi_park_ticket'||
              mainForm.data.item_type === 'single_ticket'||
              mainForm.data.item_type === 'bundle_ticket'
            " :title="$t('form.product.invisibleLabel')" :name="2">
            <el-row v-for="(item, index) in mainForm.data.invisible_labels_attributes" :key="index" v-show="item._destroy !== true" class="mb-interval-tiny">
              <el-col :md="24" :lg="8" class="mr-interval-small mb-interval-tiny">
                <el-form-item :label="$t('form.common.cnName')" :prop="`invisible_labels_attributes.${index}.name`">
                  <el-input v-model="item.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="24" :lg="8" class="mr-interval-small mb-interval-tiny">
                <el-form-item :label="$t('form.common.enName')" :prop="`invisible_labels_attributes.${index}.name_en`">
                  <el-input v-model="item.name_en" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                </el-form-item>
              </el-col>
              <el-button type="danger" @click="() => handleMainFormInvisibleLabelsItemDelBtnClick(item, index)">{{ $t('button.delete') }}</el-button>
            </el-row>
            <el-form-item>
              <el-button icon="el-icon-plus" @click="handleMainFormInvisibleLabelsAddBtnClick">{{ $t('button.add') }}</el-button>
            </el-form-item>
          </el-collapse-item>
          <!-- 不可见标签结束 -->
          <!-- 图片开始 -->
          <el-collapse-item v-if="
              mainForm.data.item_type === dataDictionary['003']['001'].code ||
              mainForm.data.item_type === dataDictionary['003']['002'].code ||
              mainForm.data.item_type === dataDictionary['003']['003'].code ||
              mainForm.data.item_type === dataDictionary['003']['004'].code ||
              mainForm.data.item_type === dataDictionary['003']['005'].code ||
              mainForm.data.item_type === dataDictionary['003']['008'].code ||
              mainForm.data.item_type === 'ticket_package'||
              mainForm.data.item_type === 'package' ||
              mainForm.data.item_type === 'multi_park_ticket'||
              mainForm.data.item_type === 'single_ticket'||
              mainForm.data.item_type === 'bundle_ticket'
            " :title="$t('text.image')" :name="3">
            <el-form-item>
              <importImg :limit="100" :data="mainForm.data.images" @change="handleMainFormImgChange"></importImg>
            </el-form-item>
            <el-form-item>{{ $t('form.product.recommendedSize') }}: 750x741</el-form-item>
          </el-collapse-item>
          <!-- 图片结束 -->
          <!-- 购买须知开始 -->
          <el-collapse-item v-if="mainForm.data.item_type === dataDictionary['003']['001'].code || mainForm.data.item_type === dataDictionary['003']['003'].code" :title="$t('form.product.buyNotices')" :name="4">
            <div>
              <div v-for="(item, index) in mainForm.data.notices_attributes" :key="index" v-show="item._destroy !== true" class="mb-interval-tiny">
                <el-row>
                  <el-col :md="24" :lg="7" class="mr-interval-small mb-interval-tiny">
                    <el-form-item :label="$t('form.common.cnName')" :prop="`notices_attributes.${index}.title`">
                      <el-input v-model="item.title" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7" class="mr-interval-small mb-interval-tiny">
                    <el-form-item :label="$t('form.common.enName')" :prop="`notices_attributes.${index}.title_en`">
                      <el-input v-model="item.title_en" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7" class="mb-interval-tiny">
                    <el-form-item :label="$t('form.product.displayOrder')" :prop="`notices_attributes.${index}.display_order`">
                      <el-input v-model="item.display_order" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24" class="mb-interval-tiny">
                    <el-form-item :label="$t('form.product.contentCn')">
                      <el-input v-model="item.detail" type="textarea" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.TEXT_AREA.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24" class="mb-interval-tiny">
                    <el-form-item :label="$t('form.product.contentEn')">
                      <el-input v-model="item.detail_en" type="textarea" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.TEXT_AREA.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24" class="mb-interval-tiny">
                    <el-form-item>
                      <el-button type="danger" @click="() => handleMainFormNoticesItemDelBtnClick(item, index)">{{ $t('button.delete') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <el-form-item>
              <el-button icon="el-icon-plus" @click="handleMainFormNoticesAddBtnClick">{{ $t('button.add') }}</el-button>
            </el-form-item>
          </el-collapse-item>
          <!-- 购买须知结束 -->
          <!-- 商品型号开始 -->
          <el-collapse-item v-if="mainForm.data.item_type === dataDictionary['003']['001'].code || mainForm.data.item_type === dataDictionary['003']['003'].code" :title="$t('form.product.shopStock')" :name="5">
            <div>
              <div v-for="(item, index) in mainForm.data.shop_item_stocks_attributes" :key="index" v-show="item._destroy !== true" class="mb-interval-tiny">
                <el-row>
                  <el-col :md="24" :lg="7">
                    <!-- 上架 -->
                    <el-form-item :label="$t('form.product.online')" :prop="`shop_item_stocks_attributes.${index}.online`">
                      <el-switch v-model="item.online"> </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.common.cnName')" :prop="`shop_item_stocks_attributes.${index}.name`">
                      <el-input @change="(data) => { return handleStocksChange(data, 'name', index) }" v-model="item.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.common.enName')" :prop="`shop_item_stocks_attributes.${index}.name_en`">
                      <el-input @change="(data) => { return handleStocksChange(data, 'name_en', index) }" v-model="item.name_en" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7" v-if="!appName.includes('wholesale')">
                    <el-form-item :label="$t('SKU ID')">
                      <el-input v-model="item.sku_id" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.sellingPrice')" :prop="`shop_item_stocks_attributes.${index}.price_f`">
                      <el-input v-model="item.price_f" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.linePrice')" :prop="`shop_item_stocks_attributes.${index}.line_price_f`">
                      <el-input v-model="item.line_price_f" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 供货商开始 -->
                <el-row>
                  <el-form-item :label="$t('form.product.supplier')" :prop="`shop_item_stocks_attributes.${index}.shop_item_stock_suppliers_attributes`">
                    <el-row></el-row>
                    <el-row v-for="(supplier, i) in mainForm.data.shop_item_stocks_attributes[index].shop_item_stock_suppliers_attributes" :key="i" v-show="supplier._destroy !== true">
                      <!-- 供货商 -->
                      <el-col :md="24" :lg="7">
                        <el-form-item :label="$t('form.product.supplier')" :prop="`shop_item_stocks_attributes.${index}.shop_item_stock_suppliers_attributes.${i}.supplier_id`" label-width="100px">
                          <el-select v-model="supplier.supplier_id" class="width-fill" :placeholder="$t('placeholder.defaultSelect')" clearable filterable @change="$forceUpdate()">
                            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <!-- 成本价 -->
                      <el-col :md="24" :lg="7">
                        <el-form-item :label="$t('form.product.costPrice')" :prop="`shop_item_stocks_attributes.${index}.shop_item_stock_suppliers_attributes.${i}.price_f`">
                          <el-input v-model="supplier.price_f" :placeholder="$t('placeholder.defaultInput')" @input="handleCostPriceChange" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="24" :lg="7">
                        <el-button class="marginLeft20" type="danger" @click="() => handleShopItemStockSuppliersDeleteBtnClick(supplier, index, i)">{{ $t('button.delete') }}</el-button>
                      </el-col>
                      <el-col :md="24" :lg="24">
                        <el-divider></el-divider>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-button icon="el-icon-plus" @click="() => handleShopItemStockSuppliersAddBtnClick(index)">{{ $t('button.add') }}</el-button>
                    </el-row>
                  </el-form-item>
                </el-row>
                <!-- 供货商结束-->
                <el-row>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('text.image')">
                      <importImg :limit="1" :data="item.image" @change="fileData => handleMainFormShopItemStocksImgChange(fileData, item, index)"></importImg>
                      <div>{{ $t('form.product.recommendedSize') }}: 176x200</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.slaingStock')" :prop="`shop_item_stocks_attributes.${index}.saling_stock`">
                      <el-input v-model="item.saling_stock" :disabled="!!item.id" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.warningStock')" :prop="`shop_item_stocks_attributes.${index}.warning_stock`">
                      <el-input v-model="item.warning_stock" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7" v-if="appName !== 'fooyo' && !appName.includes('wholesale')">
                    <el-form-item :label="$t('form.product.lockingStock')" :prop="`shop_item_stocks_attributes.${index}.inventory_quantity`">
                      <el-input v-model="item.inventory_quantity" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="appName.includes('wholesale') && (mainForm.data.wholesale_type === 'wholesale' || mainForm.data.wholesale_type === 'retail_and_wholesale')">
                  <el-col :md="24" :lg="24">
                    <el-form-item :label="$t('form.product.wholesalePrice')" :prop="`shop_item_stocks_attributes.${index}.tierX_1`">
                      <ul class="wholesale">
                        <li v-for="(tier, tIndex) in wholesalePriceArr[index]" :key="tIndex">
                          <div class="boder-b">{{tier.name}}</div>
                          <div>
                            <el-input @change="(data) => { return handleStocksChange(data, 'tierX_1', index, tIndex) }" v-model="tier.price_f" type="number" :placeholder="$t('placeholder.defaultInput')"></el-input>
                          </div>
                        </li>
                      </ul>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24">
                    <el-form-item>
                      <el-button type="danger" @click="() => handleMainFormShopItemStocksDelBtnClick(item, index)">{{ $t('button.delete') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-divider></el-divider>
                </el-form-item>
              </div>
            </div>
            <el-form-item>
              <el-button icon="el-icon-plus" @click="handleMainFormShopItemStocksAddBtnClick">{{ $t('button.add') }}</el-button>
            </el-form-item>
          </el-collapse-item>
          <!-- 商品型号结束 -->
          <el-collapse-item v-if="mainForm.data.item_type === dataDictionary['003']['001'].code || mainForm.data.item_type === dataDictionary['003']['003'].code" :title="$t('form.product.preferences')" :name="6">
            <div>
              <el-row>
                <el-col :md="24" :lg="7">
                  <el-form-item class="my-label" :label="$t('form.product.allowMultiple')" label-width="200px" prop="multiple_preferences">
                    <el-switch v-model="mainForm.data.multiple_preferences"> </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-for="(item, index) in mainForm.data.shop_item_preferences_attributes" :key="index" v-show="item._destroy !== true" class="mb-interval-tiny">
                <el-row>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.title')" :prop="`shop_item_preferences_attributes.${index}.name`">
                      <el-input v-model="item.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.displayOrder')" :prop="`shop_item_preferences_attributes.${index}.display_order`">
                      <el-input v-model="item.display_order" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.minCount')" :prop="`shop_item_preferences_attributes.${index}.min_count`">
                      <el-input v-model="item.min_count" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="7">
                    <el-form-item :label="$t('form.product.maxCount')" :prop="`shop_item_preferences_attributes.${index}.max_count`">
                      <el-input v-model="item.max_count" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24">
                    <el-form-item :label="$t('form.product.preferenceOptions')">
                      <el-row v-for="(subItem, subIndex) in item.preference_options_attributes" :key="subIndex" v-show="subItem._destroy !== true" class="mb-interval-tiny">
                        <el-col :md="24" :lg="7" class="mr-interval-small mb-interval-tiny">
                          <el-form-item :label="$t('form.product.name')" label-width="100px" :prop="`shop_item_preferences_attributes.${index}.preference_options_attributes.${subIndex}.name`">
                            <el-input v-model="subItem.name" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :md="24" :lg="7" class="mr-interval-small mb-interval-tiny">
                          <el-form-item :label="$t('form.product.price')" label-width="100px" :prop="`shop_item_preferences_attributes.${index}.preference_options_attributes.${subIndex}.price`">
                            <el-input v-model="subItem.price" :placeholder="$t('placeholder.defaultInput')" :maxlength="constant.FORM_OPTION.INPUT.MAX_LENGTH.COMMON"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-button type="danger" @click="handleMainFormPreferenceOptionsDelBtnClick(subItem, item, subIndex, index)">{{
                          $t('button.delete')
                        }}</el-button>
                      </el-row>
                      <el-form-item label-width="100px">
                        <el-button icon="el-icon-plus" @click="() => handleMainFormPreferenceOptionsAddBtnClick(item, index)">{{ $t('button.add') }}</el-button>
                      </el-form-item>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="24" :lg="24">
                    <el-form-item>
                      <el-button type="danger" @click="() => handleMainFormShopItemPreferencesDelBtnClick(item, index)">{{ $t('button.delete') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-divider></el-divider>
                </el-form-item>
              </div>
            </div>
            <el-form-item>
              <el-button icon="el-icon-plus" @click="handleMainFormShopItemPreferencesAddBtnClick">{{ $t('button.add') }}</el-button>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        <el-divider></el-divider>
        <el-row type="flex" justify="center">
          <el-button @click="handleMainFormCancelClick">{{ $t('button.cancel') }}</el-button>
          <el-button type="primary" @click="handleMainFormSubmitClick">{{ $t('button.confirm') }}</el-button>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Logic from './index.js'
export default Logic
</script>

<style lang="scss" scope>
@import "./index.scss";
</style>
